<template>

    <div v-bind:class="['action-item', { 'multi-selected': isMultiSelected }, { 'header-only': !expanded }, { 'expanded': expanded }, { 'grey-out': !expanded && hasExpanded }]" :key="'ai-' + item.actionItemId">
      <div @click="click" style="position: relative" class="action-item-header">
          <i v-bind:class="['fa', 'fa-check', 'selected-check']" style="color:green" v-if="isMultiSelected"></i>
          <i v-bind:class="['fa', { 'fa-angle-up': expanded }, { 'fa-angle-down': !expanded }, 'collapsed-state']" v-if="!inModal" ></i>
          <div v-if="isInternalUser" class="action-item-number" is="text-highlighter" :searchText="quickSearchText" :text="item.actionItemId">{{item.actionItemId}}</div>
          <div is="text-highlighter" :searchText="quickSearchText" :text="item.participantName"></div>
          <div is="text-highlighter" :searchText="quickSearchText" :text="item.employerName"></div>
          <div is="text-highlighter" :searchText="quickSearchText" :text="item.description"></div>
          <div class="summary-list-div">
            <div class="summary-list" v-if="isInternalUser" >
              <li v-for="summary in item.summary" :key="summary.key">
                  {{summary.value}}
              </li>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-between secondary-info">
              <div class="assigned-to" v-if="isInternalUser">
                <a href="#" @click.stop="assign" is="text-highlighter" :searchText="quickSearchText" :text="item.assignmentText"></a>
              </div>
              <div>{{$formatters.dateTime(item.createdDate)}}</div>
          </div>
          <div v-if="expanded && item.orderEffectiveDate" class="d-flex flex-row justify-content-between secondary-info">
            <div>
              <span v-if="!item.isRenewal">Order</span>
              <span v-if="!item.isRenewal">{{$formatters.date(item.orderEffectiveDate)}}</span>
            </div>
          </div>
          <div v-if="inTheFuture(item)" class="d-flex flex-row justify-content-between secondary-info">
              <div class="assigned-to">This Action item Effective On {{$formatters.date(item.availableDate)}}</div>
          </div>
      </div>

      <div v-if="expanded" class="action-item-details">
        <hr v-if="showTopHorizontalRule"/>

        <div v-if="defaultText">
          <br>
          <div>{{defaultText}}</div>
        </div>

        <div class="values" v-if="values && values.length > 0">
            <table class="table table-condensed table-sm">
                <tbody v-for="v in values" v-bind:key="v.name">
                    <tr v-if="v.value">
                        <td class="bold text-nowrap">{{v.name}}</td>
                        <td v-bind:title="v.originalValue" class="text-right">{{v.value || ''}}<i v-if="v.isLongName" class="fa fa-info-circle" aria-hidden="true"></i></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="links" v-if="links && links.length > 1">
            <table class="table table-condensed table-sm">
                <tbody v-for="(link) in links" v-bind:key="link.text">
                    <tr v-if="link.text">
                        <td v-if="link.click">
                            <a href="#" @click="link.click">{{link.text}}</a>
                        </td>
                        <td v-if="link.href">
                            <router-link :to="link.href">{{link.text}}</router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="links" v-if="item.files && item.files.length > 0">
          <div style="font-size: smaller">Files</div>
          <div v-for="file in item.files" :key="file.id">
            <a href="#" v-on:click="downloadFile(file.link)">{{$formatters.truncate(file.name, 35)}}</a>
          </div>
        </div>

        <div v-if="customComponent && customComponent">
          <div :is="customComponent" :item="item"></div>
        </div>

        <div v-if="isInternalUser && item.history && item.history.length > 0" class="mt-2 action-item-history">
            <div v-for="(history, index) in item.history" :key="index">
              <li>
                  <span :title="timeAndUser(history)">
                    <span v-if="history.isFile">
                      Attached <a href="#" @click.prevent="downloadFile(history.link)">{{ history.bag.storageFile.fileName }}</a> <i class="fa fa-paperclip"></i>
                    </span>
                    <span v-else-if="history.isComment">
                      <amf-expandable-text :text="history.bag.displayText" :expanded="!!history.isFirst" />
                    </span>
                    <span v-else>
                      {{ history.bag.displayText }}
                    </span>
                  </span>
                </li>
            </div>
        </div>

        <hr>

        <div class="mt-3 d-flex flex-row justify-content-between">
            <div class="d-flex flex-row">
                <amf-button v-for="b in buttonsInternal" v-bind:key="b.text" class="mr-1" :class="[b.css]" :onClick="b.click">{{b.text}}</amf-button>
                <div v-if="isInternalUser && buttonsAssignment && buttonsAssignment.length > 0">
                    <button class="btn btn-primary" type="button" id="actionItemAssignDropDown" data-toggle="dropdown">
                      <span>Assign</span>
                    </button>
                    <div class="dropdown-menu" :aria-labelledby="'dropDown'">
                      <div v-for="b in buttonsAssignment" :key="b.text">
                        <a href="#" class="dropdown-item" @click.prevent="b.click" >{{b.text}}</a>
                      </div>
                    </div>
                </div>
            </div>

            <div class="d-flex flex-row">
                <button v-if="isInternalUser" class="btn btn-turquoise btn-sm" type="button" id="actionItemDropDown" data-toggle="dropdown">
                    <span class="fa fa-ellipsis-v"></span>
                </button>
                <div v-if="isInternalUser" class="dropdown-menu dropdown-menu-right" :aria-labelledby="'dropDown'">
                  <a href="#" class="dropdown-item" @click.prevent="addComment">Comment</a>
                  <a href="#" class="dropdown-item" @click.prevent="$refs.uploader.click()">Attach Files</a>
                  <a v-if="!inModal" href="#" class="dropdown-item" @click.prevent="showInModal">Show in Window</a>
                </div>
            </div>
        </div>
      <div class="d-none">
        <input id="upload" type="file" ref="uploader" style="display: none;" multiple @change="onSelectAttachments"/>
      </div>
      </div>
    </div>

</template>

<script>
import ActionItemAssignmentModal from './ActionItemAssignmentModal.vue';
import ActionItemRegistry from './types/registry';
import TextHighlighter from "../framework/TextHighlighter";
import advertise from "../framework/utils/advertise";
import { actionItemUserRolesMap } from "../user/user-labels";
import ActionItemModal from './ActionItemModal';

export default {
  components: {
    TextHighlighter
  },
  props: ["item", "quickSearchText", "mode"],
  data() {
    return {
      values: [],
      links: [],
      defaultText: null,
      buttons: "Done",
      buttonsInternal: null,
      buttonsAssignment: null,
      customComponent: null,
      actionItemTypes: null
    };
  },
  computed: {
    ...amfx.map("session", "isInternalUser,user,impersonatedUser"),
    ...amfx.map("actionItems", "selectedItems,hasExpanded"),
    expanded() {
      return this.item.expanded;
    },
    isMultiSelected() {
      return this.item && this.selectedItems.includes(this.item.actionItemId);
    },
    showTopHorizontalRule() {
      return (this.customComponent) ||
        (this.values && this.values.length > 0) ||
        (this.links && this.links.length > 1) ||
        (this.item.comments && this.item.comments.length > 0);
    },
    inModal() {
      return this.mode == "modal";
    }
  },
  methods: {
    ...amfx.map("actionItems", "expandItem,collapseItem,storeAddComment:addComment,uploadAttachments,validateCanChangeStatus,changeStatus,collapseAll,toggleMultiSelection,getActionItemTypes,assignToRole,assignToUser,loadDetails"),
    inTheFuture(item) {
      if (!item.availableDate) return false;
      return moment(item.availableDate).isAfter(new Date());
    },
    click(e) {
      if (this.inModal) return;
      this.$emit("expand", e);
      if (e.ctrlKey && this.isInternalUser) {
        this.toggleMultiSelection(this.item);
        return;
      }
      if (this.expanded) {
        this.collapseItem(this.item.actionItemId);
      } else {
        this.collapseAll();
        this.expandItem(this.item.actionItemId);
      }
    },
    async assign() {
        var data = await modalService.show("action-item-assignment-modal", ActionItemAssignmentModal, { actionItem: this.item });
    },
    close() {
      this.collapseItem(this.item.actionItemId);
    },
    async init() {
        if (!this.item) return;

        this.buttons = "Done";

        var reg = ActionItemRegistry.get(this.item.itemType);

        if(reg.redirect) {
            let redirect = reg.redirect(this.item);
            this.$router.push(redirect);
            this.close();
        }

        this.buttons = _.isFunction(reg.buttons) ? reg.buttons(this.item) : reg.buttons || this.buttons;

        this.customComponent = reg.component || this.customComponent;
        this.onComplete = reg.onComplete;

        this.values = this.createValues(reg);
        this.defaultText = reg.defaultText;

        this.links = await (reg.links || this.createDefaultLinks)(this.item);

        this.actionItemTypes = await this.getActionItemTypes();

        this.addCompleteButton();
        this.addAssignmentButtons();

        if (this.links.length > 0) {
            this.$router.push(this.links[0].href);
        }

    },
    createValues(reg) {
        let values = _.isFunction(reg.values) ? reg.values(this.item) : reg.values || [];

        if(values){
           for(let i = 0; i < values.length; ++i){
                if(values[i].value != null && values[i].value.length > 21 && values[i].value.indexOf(' ') < 0){
                    values[i].originalValue = values[i].value;
                    values[i].value = utils.truncateString(values[i].value, 23);
                    values[i].isLongName = true;
                }
           }
        }

        return values;
    },
    createDefaultLinks() {
        let links = [];

        if (this.item.participantId) {
            links.push({
                text: `View ${this.item.participantName}`,
                href: `/participant/${this.item.participantId}/general`,
            });
        } else if (this.item.employerId)
            links.push({
                text: `View ${this.item.employerName}`,
                href: `/employer/${this.item.employerId}/general`,
            });

        return links;
    },
    async addComment() {
        let notes = await modalService.multiLineInput("Enter comments");
        await this.storeAddComment({ actionItemId: this.item.actionItemId, comment: notes });
    },
    async showInModal() {
        modalService.show("action-item-modal", ActionItemModal, { item: this.item, width: 1000 });
    },
    async onSelectAttachments() {
      const files = Array.from(this.$refs.uploader.files);

      if (!files || !files.length) {
        return;
      }

      const MAX_FILE_UPLOAD_SIZE = 29000000; // 29Mb
      const totalFileSize = files.reduce((acc, file) => acc + file.size, 0);

      if (totalFileSize > MAX_FILE_UPLOAD_SIZE) {
        toastr.error("Total size of all files cannot exceed 29Mb");
        return;
      }

      const formData = new FormData();
      formData.append('actionItemId', this.item.actionItemId);

      for(var i = 0; i < files.length; i++) {
        formData.append(`file${i}`, files[i]);
      }

      this.uploadAttachments({ actionItemId: this.item.actionItemId, formData });

      this.$refs.uploader.value = null;
    },

    async downloadFile(fileLink) {
      await romeApi.download(`${this.item.employerId}/${fileLink}`);
    },

    async refresh() {
      await this.loadDetails(this.item.actionItemId);
      this.init();
    },

    addCompleteButton() {
        var canComplete = this.item.operations && _.some(this.item.operations, o => o.operationType == "complete");

        this.buttonsInternal = [];

        if (canComplete) {
            if (!this.buttons || ["Confirm", "Complete", "Done"].includes(this.buttons)) {
              this.buttonsInternal = [
                  { text: this.buttons || "Confirm", css: "btn-success", newStatus: "completed" }
              ]
            } else if (this.buttons == "Accept") {
                this.buttonsInternal = [
                    { text: "Accept", css: "btn-success", newStatus: "approved" },
                ];
            } else if (this.buttons == "Done/Reject") {
                this.buttonsInternal = [
                    { text: "Done", css: "btn-success", newStatus: "completed" },
                    { text: "Reject", css: "btn-danger", newStatus: "rejected" },
                ];
            } else if (_.isArray(this.buttons)) {
                this.buttonsInternal = _.clone(this.buttons);
            } else if (this.buttons == "none") {
                this.buttonsInternal = [];
            } else {
                throw "Unrecognized value buttons=" + this.buttons;
            }
        }

        this.buttonsInternal.forEach(b => {
            b.actionItem = this.item;
            b.css = b.css || "btn-default";
            if (!b.click) {
                b.click = async () => {
                    var { canChangeStatus, overrideValidation } = await this.validateChangeStatusRequest(this.item, b.newStatus);

                    if(canChangeStatus || overrideValidation){
                        if (!(await modalService.confirm(this.getConfirmationText(b.text)))) return;
                        await this.changeActionItemStatus(b.newStatus, overrideValidation);
                    }
                }
            }
        });
    },

    addAssignmentButtons() {
      this.buttonsAssignment = [];

      if (_.some(this.item.operations, o => o.operationType == "assign-to-me")) {
          this.buttonsAssignment.push({
                text: "To Me",
                click: async () => {
                  var userName = this.user.fullName;
                  var userId = this.user.userId;
                  if (this.impersonatedUser) {
                    userName = this.impersonatedUser.firstName + " " + this.impersonatedUser.lastName;
                    userId = this.impersonatedUser.userId;
                  }
                  await this.assignToUser({ actionItemId: this.item.actionItemId, userId: userId, assignmentText: userName });
                  toastService.success(`Action Item assigned to ${userName}`);
                  await this.refresh();
                }
              });
        }

        this.item.operations.filter(o => o.operationType == "assign-to-user").forEach(o => {
            var role = actionItemUserRolesMap[o.role].name;
            var userId = o.userId;
            var userFullName = o.userFullName;
            this.buttonsAssignment.push({
              text: `To ${userFullName} (${role})`,
              click: async () => {
                  await this.assignToUser({ actionItemId: this.item.actionItemId, userId: userId, assignmentText: userFullName });
                  toastService.success(`Action Item assigned to ${userFullName}`);
                  await this.refresh();
              }
              });
        });

        this.item.operations.filter(o => o.operationType == "assign-to-role").forEach(o => {
              var role = o.role;
              this.buttonsAssignment.push({
                text: "To " + actionItemUserRolesMap[role].name,
                click: async () => {
                    await this.assignToRole({ actionItemId: this.item.actionItemId, roleId: role });
                    toastService.success(`Action Item assigned to ${actionItemUserRolesMap[role].name}`);
                    await this.refresh();
                }
                });
            });
    },

    getConfirmationText(buttonText) {
        if (["Done", "Approve", "Reject"].includes(buttonText)) {
            return `This action item will be marked as '${buttonText}'. Are you sure?`
        } else {
            return "Are you sure?";
        }
    },

    async changeActionItemStatus(newStatus, overrideValidation) {
        try {
            if (newStatus == "rejected") {
                let notes = await modalService.multiLineInput("Enter rejection notes", null, "Rejection reason");
                await this.changeStatus({ actionItem: this.item, newStatus: newStatus, notes, overrideValidation });
            } else {
                await this.changeStatus({ actionItem: this.item, newStatus: newStatus, onComplete: this.onComplete, overrideValidation });
            }
            this.refreshPermissions();
        }
        catch(err)
        {
            console.log(err);
            modalService.info(err.message);
        }
    },

    async validateChangeStatusRequest(newStatus){
        if(newStatus == 'rejected') return { canChangeStatus: true, overrideValidation: false }
        let result = await this.validateCanChangeStatus({ actionItem: this.item, newStatus:newStatus });
        let overrideValidation = false;

        if(!result.ok && this.isInternalUser){
            var errors = [];
            errors.push({error: result.message});
            var dto = {errors: errors};

            overrideValidation = await modalService.info(result.message, {
              buttonsCustom: [{
                name: "Override",
                onClick: async () => await modalService.confirm('Are you sure you want to OVERRIDE VALIDATION on this action item and complete it?')
              },
              {
                name: "Download Errors",
                onClick: async () =>await romeApi.postDownload(`actionitem/v-2/${this.item.actionItemId}/errors/download`, null, dto)
              }]
            });

        } else if (!result.ok) {
          await modalService.info(result.message);
        }
        return {
          canChangeStatus: result.ok,
          overrideValidation
        };
    },
    timeAndUser(history) {
      var time = moment(history.changeDate).format('MM/DD/YYYY hh:mm a');
      return `${history.userName} ${time}`;
    }

  },
  watch: {
    expanded: {
      immediate: true,
      handler(v) {
        if (this.expanded) this.init();
      }
    }
  }
};

</script>

<style lang="scss" scoped>
.action-item {
    padding: 0.75rem;
    margin: 4px;
    opacity: 1;
    border-radius: 4px;
    color: #333;
    opacity: 1;
    border: 1px solid #c0e3f0;

  &.expanded {
    background-color: #fafafa !important;
    border: 2px solid rgb(3, 145, 197);
    box-shadow: 0 2px 5px 0 rgba(0,0,0,.16), 0 2px 5px 0 rgba(0,0,0,.23);
    transition: box-shadow 0.7s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
  }

  &.header-only {
      background-color: white;

      &.multi-selected {
        background: #89d2ea;
      }

      &:hover {
          z-index: 999;
          background-color: #e1f6ff;
          border: 1px solid #81c8e2;
          // -webkit-box-shadow: 0 14px 24px rgba(62,57,107,.2);
          // box-shadow: 0 14px 24px rgba(62,57,107,.2);
          // box-shadow: 0 9px 23px rgba(0, 0, 0, 0.18), 0 5px 5px rgba(0, 0, 0, 0.12) !important;
      }
  }

  &.grey-out {
    color: #aaa;

    .assigned-to > a {
      color: #aaa !important;
    }
  }
}

.action-item-header {
  text-align: left;
  cursor: pointer;

  .selected-check {
    position: absolute;
    top: -6px;
    right: 12px;
  }

  .collapsed-state {
    position: absolute;
    top: -6px;
    right: 0;
  }

  .card-processor {
    position: absolute;
    top: 18px;
    font-size: small;
    right: 0;
  }

  .action-item-number {
    position: absolute;
    top: 5px;
    right: 0;
  }

  .secondary-info {
    margin-top: 0.5rem;
    font-size: 80%;
  }

  .assigned-to a {
    color: black;
  }

  .summary-list {
    li {
      list-style-type: none;
      margin-top: 0.0rem;
      font-size: 80%
    }
  }
  .summary-list-div {
    margin-top: 0.5rem;
  }
}

.action-item-details {
    text-align: left;
    border-radius: 4px;
    color: #333;
    // box-shadow: 0 2px 5px 0 rgba(0,0,0,.16), 0 2px 5px 0 rgba(0,0,0,.23);
    // box-shadow: 0 9px 23px rgba(0, 0, 0, 0.09), 0 5px 5px rgba(0, 0, 0, 0.06) !important;
    // transition: box-shadow 0.7s cubic-bezier(0.25, 0.8, 0.25, 1) !important;

    .table td a {
         color: black
    }

    table {
        margin-bottom: 0;
        tbody {
            border: 0;
        }
        td {
            border-top: transparent;
            padding: 0;
        }
        .bold{
            font-weight: bold;
        }
    }

    hr {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }

    .action-item-history {
      max-height: 400px;
      overflow-y: auto;
    }
 }
</style>



// WEBPACK FOOTER //
// src/action-items/ActionItem.vue